function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2 className="about-title">Sobre a Accium</h2>

        <p className="about-text">
          Fundada em <strong>2024</strong>, na cidade de{" "}
          <strong>Chapecó</strong>, a <strong>Accium</strong> nasceu com o
          propósito de oferecer <strong>soluções completas em aço</strong>,
          unindo tecnologia, experiência e personalização. Nossa linha é ampla e
          versátil — chapas, tubos, laminados, perfis estruturais e
          serralheiros, além de calhas, algerosas e acessórios — com fabricação
          sob medida e serviços especializados que transformam a matéria-prima
          conforme as necessidades de cada projeto.
        </p>

        <p className="about-text">
          Com infraestrutura moderna, dispomos de máquinas para{" "}
          <strong>corte e dobra de chapas</strong>, além da produção de{" "}
          <strong>perfis e telhas metálicas personalizadas</strong>. Na{" "}
          <strong>Accium</strong>, você encontra diversas soluções integradas
          para execução de projetos com precisão, durabilidade e desempenho
          superior.
        </p>

        <div className="cards-grid">
          <div className="about-card">
            <div className="card-icon">🧭</div>
            <h3 className="card-title">Missão</h3>
            <p className="card-text">
              Oferecer soluções completas em aço, combinando nossa linha
              diversificada de produtos com serviços de corte, dobra e
              fabricação. Atendemos às necessidades específicas de cada projeto,
              gerando valor e satisfação aos nossos clientes.
            </p>
          </div>

          <div className="about-card">
            <div className="card-icon">🔭</div>
            <h3 className="card-title">Visão</h3>
            <p className="card-text">
              Crescer de forma sustentável, agregando valor aos projetos
              atendidos e construindo um futuro de sucesso junto aos nossos
              clientes.
            </p>
          </div>

          <div className="about-card">
            <div className="card-icon">⚙️</div>
            <h3 className="card-title">Valores</h3>
            <p className="card-text">
              Atuamos guiados por princípios sólidos: integridade,
              adaptabilidade, originalidade, visão integrada, perspectiva
              sistêmica e zelo pelas pessoas. Acreditamos que a gestão
              responsável é o caminho para um crescimento consciente e
              duradouro, gerando impactos positivos na sociedade e no meio
              ambiente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
